'use client';

import type { GetCampaignResponse } from '@ab-inbev-eu/campaign/src/models/campaign';
import type { ICampaignActionResponse } from '@ab-inbev-eu/action/src/utils/types';
import { useEffect } from 'react';

import { useApplicationStore } from '../../stores/application.store';

import { ThemeProvider } from './ThemeProvider';

export function Providers(
  props: Readonly<{
    children: React.ReactNode;
    campaign: GetCampaignResponse;
    lng: string;
    qrId: string;
    campaignActions: ICampaignActionResponse['data'];
    campaignScansCount: number;
  }>,
) {
  useEffect(() => {
    useApplicationStore.setState({
      campaign: props.campaign,
      campaignActions: props.campaignActions,
      campaignScansCount: props.campaignScansCount,
    });
  }, [props.campaign, props.campaignActions, props.campaignScansCount]);

  return (
    <ThemeProvider lng={props.lng} template={props.campaign.branding}>
      {props.children}
    </ThemeProvider>
  );
}
